export enum ServicesByStore {
  AbrazivnayaPolirovkaKuzova = 12,
  AntibakterialnayaObrabotkaSalonaAvtomobilya = 228,
  Avtokhimchistka = 9,
  Avtomoyka = 10,
  AvtomoykaIDetejling = 8,
  Avtoparki = 232,
  Avtoservice = 47,
  Balansirovka = 3,
  ByistrayaOchistkaDvigatelya = 174,
  DiagnostikaDvigatelyaIElektronnyihSistem = 182,
  DiagnostikaXodovoyChasti = 234,
  JidkostiIFiltryi = 197,
  KhimicheskayaPromyvkaInzhektora = 36,
  KompleksnayaDiagnostikaIspravnyiyAvtomobil = 186,
  KompleksnoeTo = 231,
  KonditsionerKlimat = 37,
  LegkovoyShinomontazh = 2,
  MoykaDnischaAvto = 210,
  MoykaDvigatelyaParom = 13,
  OchistkaSistemyiVpryiska = 175,
  OchistkaSistemyiVpuska = 171,
  OformitPolisOsagoOnlayn = 229,
  PokraskaDiskov = 209,
  PolirovkaStekol = 14,
  PovtornayaOshipovkaZimnihShin = 213,
  PravkaDiskov = 43,
  ProdlenieSrokaSlujbyiDvigatelya = 172,
  PromyivkaToplivnoySistemyi = 173,
  RaskoksovkaDvigatelya = 176,
  ReglamentnoeTo = 15,
  RegulirovkaSvetaFar = 225,
  RemontElektrooborudovaniya = 31,
  RemontIPokraskaDiskov = 39,
  RemontLityihDiskov = 206,
  RemontShin = 4,
  ServisMaslyanoySistemyi = 170,
  SezonnoeKhranenie = 1,
  Shinomontaj = 48,
  ShinomontajRahKolyos = 230,
  SkhodRazval = 24,
  SvarkaDiskovArgonom = 207,
  TradeIn = 226,
  Transmissiya = 51,
  UdalenieKatalizatora = 45,
  UltrazvukovayaChistkaForsunok = 35,
  UstanovkaZamenaDatchikovDavleniya = 44,
  ZamenaAkkumulyatora = 105,
  ZamenaBachkaSistemyiOhlajdeniya = 99,
  ZamenaEurVMehanizmeRulevoy = 142,
  ZamenaGeneratora = 103,
  ZamenaGlushitelya = 77,
  ZamenaGrm = 27,
  ZamenaKardannogoSharniraRulevogoUpravleniya = 147,
  ZamenaKatushkiZajiganiya = 107,
  ZamenaLampBlijnegoSveta = 110,
  ZamenaMaslaIMaslyanogoFiltra = 16,
  ZamenaMehanicheskogoKompressora = 65,
  ZamenaNasosaGurEgur = 140,
  ZamenaNasosaOhlajdeniyaDvs = 95,
  ZamenaOchistkaDrosselnoyZaslonki = 59,
  ZamenaOkhlazhdayushcheyZhidkosti = 22,
  ZamenaOporyiSilovogoAgregata = 60,
  ZamenaPatrubkaSistemyiOhlajdeniya = 98,
  ZamenaPerednegoPodramnika = 151,
  ZamenaPerednihIZadnihAmortizatorov = 157,
  ZamenaPerednihIZadnihPrujin = 158,
  ZamenaPriemnoyTrubyiVyihlopnoySistemyi = 79,
  ZamenaPyilnikaRulevoyReyki = 146,
  ZamenaRadiatoraOhlajdeniyaDvigatelya = 100,
  ZamenaRadiatoraOtopitelyaSalona = 101,
  ZamenaRemnyaIRolikovVspomogatelnyih = 62,
  ZamenaRemnyaPrivodaGrm = 68,
  ZamenaRessoryi = 160,
  ZamenaRezonatora = 78,
  ZamenaRulevogoNakonechnika = 144,
  ZamenaRulevoyReyki = 143,
  ZamenaRyichagovPodveski = 154,
  ZamenaSalnika = 61,
  ZamenaSalonnogoFiltra = 20,
  ZamenaSaylentBlokaRyichaga = 155,
  ZamenaSaylentBlokaZadneyBalki = 161,
  ZamenaSharovoyOporyiPodveski = 169,
  ZamenaStartera = 104,
  ZamenaStoykiStabilizatora = 153,
  ZamenaStsepleniya = 28,
  ZamenaStupichnogoPodshipnika = 164,
  ZamenaSvecheyZajiganiya = 106,
  ZamenaSvecheyZazhiganiya = 17,
  ZamenaTermostataSistemyiOhlajdeniya = 97,
  ZamenaToplivnogoBaka = 67,
  ZamenaToplivnogoFiltra = 212,
  ZamenaToplivnogoNasosa = 66,
  ZamenaToplivnogoNasosaVBake = 76,
  ZamenaToplivnogoNasosaVyinosnogo = 75,
  ZamenaTormoznihDiskov = 233,
  ZamenaTormoznoyZhidkosti = 21,
  ZamenaTormoznyihKolodokDiskov = 126,
  ZamenaTsepiPrivodaGrm = 69,
  ZamenaTurbokompressora = 64,
  ZamenaTyagiRulevoyReyki = 145,
  ZamenaTyagiZadneyPodveski = 163,
  ZamenaVentilyatoraOhlajdeniya = 102,
  ZamenaVerhneyOporyiAmortizatora = 156,
  ZamenaVozdushnogoFiltra = 19,
  ZamenaVpusknogoKollektora = 63,
  ZamenaVtulkiStabilizatora = 152,
  ZamenaVyipusknogoKollektora = 80,
  ZamenaVyisokovoltnyhProvodov = 108,
  ZamenaZadneyBalki = 162,
}
